module.exports = __webpack_public_path__ + "fonts/fontello.d0d64de.eot";